// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid.addresses {
  grid-template-columns: repeat(8, auto);
}
form {
  background-color: #efeff7;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/address-input/address-input.component.less"],"names":[],"mappings":"AAEA;EACI,sCAAA;AADJ;AAIA;EACI,yBAAA;AAFJ","sourcesContent":["@import (reference) url('../../../styles.less');\n\n.grid.addresses {\n    grid-template-columns: repeat(8, auto);\n}\n\nform {\n    background-color: @ltpurple;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
